import React from "react";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle,
} from "@/components/ui/dialog";
import { formatReportDate } from "@/utils/tlRecordingReportHelpers";
import { formatWeekRangeLabel } from "@/utils/managerReportHelpers";
import { getCurrentIsoWeekContext, resolveIsoYearForRow } from "@/utils/isoWeek";

/**
 * @param {{ open: boolean, onClose: () => void, row: object|null, focusField?: string|null, fields: { key: string, label: string }[], isDark: boolean, textClass: string, labelClass: string, title?: string }} props
 */
const ReportTextDetailModal = ({
  open,
  onClose,
  row,
  focusField = null,
  fields,
  isDark,
  textClass,
  labelClass,
  title,
}) => {
  if (!row) return null;
  const panelClass = isDark ? "bg-slate-900 border-slate-700 text-white" : "";
  const blockClass = isDark ? "border-slate-700 bg-slate-950/40" : "border-gray-200 bg-gray-50";
  const focusMeta = focusField ? fields.find((f) => f.key === focusField) : null;
  const visibleFields = focusField ? fields.filter((f) => f.key === focusField) : fields;

  const subtitle = [
    row.assistant_name || row.agent_name,
    row.report_date ? formatReportDate(row.report_date) : null,
    row.week_number
      ? formatWeekRangeLabel(resolveIsoYearForRow(row, getCurrentIsoWeekContext().isoYear), row.week_number)
      : null,
    row.leader_name,
    row.quality_user_name,
  ].filter(Boolean).join(" · ");

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className={`max-w-3xl max-h-[90vh] overflow-y-auto ${panelClass}`}>
        <DialogHeader>
          <DialogTitle className="pr-8">
            {title || focusMeta?.label || "Rapor detayı"}
            {subtitle && (
              <span className={`block text-sm font-normal mt-1 ${labelClass}`}>{subtitle}</span>
            )}
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-3 py-1">
          {visibleFields.map((field) => {
            const value = String(row[field.key] || "").trim();
            if (!value) {
              if (focusField) {
                return (
                  <p key={field.key} className={`text-sm text-center py-6 ${labelClass}`}>Bu alanda metin yok</p>
                );
              }
              return null;
            }
            return (
              <div key={field.key} className={`rounded-lg border p-3 ${blockClass}`}>
                {!focusField && (
                  <div className={`text-xs font-semibold mb-2 ${textClass}`}>{field.label}</div>
                )}
                <div className={`text-sm whitespace-pre-wrap break-words leading-relaxed ${textClass}`}>{value}</div>
              </div>
            );
          })}
          {!focusField && visibleFields.every((f) => !String(row[f.key] || "").trim()) && (
            <p className={`text-sm text-center py-6 ${labelClass}`}>Bu kayıtta metin yok</p>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ReportTextDetailModal;
